import { ContactResponse } from 'models/contacts'

type SequenceMembership = Pick<ContactResponse, 'seq_membership_status'>

/**
 * Whether a contact is currently in the sequence, i.e. eligible for
 * "Remove from sequence" (truthy membership status that isn't 'removed').
 */
export function isInSequence(contact: SequenceMembership): boolean {
  return Boolean(
    contact.seq_membership_status && contact.seq_membership_status !== 'removed'
  )
}

/**
 * Whether a contact was removed from the sequence, i.e. eligible for
 * "Re-add to sequence".
 */
export function wasRemovedFromSequence(contact: SequenceMembership): boolean {
  return contact.seq_membership_status === 'removed'
}

export interface SequenceBulkActionEligibility {
  /** At least one selected contact is currently in the sequence. */
  canRemoveFromSequence: boolean
  /** At least one selected contact has been removed from the sequence. */
  canReAddToSequence: boolean
}

/**
 * Compute whether the bulk "Remove from sequence" / "Re-add to sequence"
 * actions apply to the current selection.
 *
 * Uses the same per-contact predicates as the per-row actions in
 * ContactsTable. A bulk action is eligible when ANY selected contact
 * qualifies (the backend skips ineligible contacts).
 */
export function getSequenceBulkActionEligibility(
  contacts: SequenceMembership[]
): SequenceBulkActionEligibility {
  return {
    canRemoveFromSequence: contacts.some(isInSequence),
    canReAddToSequence: contacts.some(wasRemovedFromSequence),
  }
}
